import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TruncatePipeModule } from '@shared/core/pipes/truncate';
import { LinkModule } from '@shared/core/components/link';

import { CartLocationButtonComponent } from './cart-location-button.shared.component';

@NgModule({
    declarations: [
        CartLocationButtonComponent
    ],
    imports: [
        CommonModule,
        TruncatePipeModule,
        LinkModule,
    ],
    exports: [
        CartLocationButtonComponent
    ],
    providers: [],
})
export class CartLocationButtonModule { }
